"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatten = void 0;
const _ = require("lodash");
/**
 * Converts an object into a path/value array.
 */
const nextKey = (keySoFar, key, pathDelimiter = ".") => `${keySoFar}${keySoFar ? pathDelimiter : ""}${key}`;
const flatten = (source, preserveObjectFields = [], preserveObjectStructures = [], flattened = {}, keySoFar = "") => {
    if (_.isUndefined(source)) {
        return;
    }
    const simpleArray = _.isArray(source) && source.filter(o => _.isObject(o)).length === 0;
    const shouldExport = _.isObject(source) && !simpleArray;
    if (shouldExport) {
        // iterate over keys in source object
        for (const k in source) {
            const key = nextKey(keySoFar, k);
            const obj = source[k];
            // escape certain fields based on name and/or value
            if (
            // check current field key is not in 'preserveObjectFields', or
            // structure of current field value does not conform to any items in
            // preserveObjectStructures.
            // if either of these are true, don't flatten the current value.
            preserveObjectFields.indexOf(k) > -1 ||
                preserveObjectStructures.some(p => _.difference(p, Object.keys(obj || {})).length === 0)) {
                flattened[key] = obj;
            }
            else {
                (0, exports.flatten)(obj, preserveObjectFields, preserveObjectStructures, flattened, key);
            }
        }
    }
    else {
        flattened[keySoFar] = source;
    }
    return flattened;
};
exports.flatten = flatten;
//# sourceMappingURL=flatten.js.map